(function () {
  function readData() {
    var el = document.querySelector("[data-rx-data]");
    if (!el) return { design: false };
    try { return JSON.parse(el.textContent); } catch (e) { return { design: false }; }
  }

  function initAll() {
    var data = readData();
    var EN = ((document.documentElement.lang || "").toLowerCase().indexOf("en") === 0);

    // ===== Intro (einmal pro Sitzung; im Editor aus; CSS blendet notfalls von selbst aus) =====
    try {
      var intro = document.getElementById("rx-intro");
      if (intro) {
        var seen = !!data.design;
        try { seen = seen || sessionStorage.getItem("rx_intro") === "1"; } catch (e) { }
        if (seen) { intro.classList.add("done"); }
        else if (!intro.dataset.rxRun) {
          intro.dataset.rxRun = "1";
          var line = EN ? "LOADING SCAN SERIES…" : "SCAN-SERIE WIRD GELADEN…";
          var typed = document.getElementById("rx-typed");
          var ti = 0;
          var t = setInterval(function () {
            if (typed) typed.textContent = line.slice(0, ++ti);
            if (ti >= line.length) clearInterval(t);
          }, 42);
          setTimeout(function () {
            var sl = document.getElementById("rx-scanline");
            if (sl) sl.classList.add("run");
            setTimeout(function () {
              intro.classList.add("done");
              try { sessionStorage.setItem("rx_intro", "1"); } catch (e) { }
            }, 350);
          }, 1750);
        }
      }
    } catch (e) { if (window.console) console.error("rx intro:", e); }

    // ===== Reveals + EKG =====
    try {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
        });
      }, { threshold: .15 });
      document.querySelectorAll(".rx-reveal").forEach(function (el) { io.observe(el); });
      var ekg = document.getElementById("rx-ekg");
      if (ekg) {
        new IntersectionObserver(function (ents, obs) {
          ents.forEach(function (en) { if (en.isIntersecting) { ekg.classList.add("in"); obs.disconnect(); } });
        }, { threshold: .4 }).observe(ekg);
      }
    } catch (e) { if (window.console) console.error("rx fx:", e); }
  }

  window.rxLandingInit = initAll;
  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", initAll);
  if (!window.__rxListener) {
    window.__rxListener = true;
    document.addEventListener("shopify:section:load", function () { initAll(); });
  }
})();